export default {
  path: '/license-term-labels',
  name: 'license-term-labels',
  component: () => import(/* webpackChunkName: "license-term-labels" */ './TermLabels'),
  meta: {
    requiresAuth: true
  }
}
